import IconCalendar from '../icons/calendar';
import formatDate from '../../helpers/format-date';
import { DateInputPrimaryTypes } from './types';

import styles from './date-input.module.css';

export default function DateInputPrimary({
  title = '',
  borderless = false,
  inputValue = '',
  placeholder = '',
  datepickerVisible,
  setDatepickerVisible,
  disabled,
  tabIndex,
  focused,
  setFocused,
  shortcuts,
  withTime,
  withoutIcon,
}: DateInputPrimaryTypes) {
  return (
    <>
      {title && (
        <div className={styles.dateInputTitle}>
          {title}

          {shortcuts && <div className={styles.shortcuts}>{shortcuts}</div>}
        </div>
      )}
      <div
        className={`${styles.dateInputValuesWrapper} ${
          borderless ? styles.dateInputValuesWrapperBorderless : ''
        }
          ${disabled ? styles.disabled : ''}
        }`}
      >
        <div
          className={`${styles.dateInputValue} ${
            inputValue ? '' : styles.dateInputValuePlaceholder
          }`}
        >
          {inputValue ? formatDate(inputValue, withTime) : placeholder}
        </div>
        {!withoutIcon && (
          <div className={styles.dateInputIcon}>
            <IconCalendar />
          </div>
        )}

        <button
          type="button"
          aria-label="Show Date Picker"
          className={styles.dateInputButton}
          onClick={() => setDatepickerVisible(!datepickerVisible)}
          tabIndex={tabIndex}
          onFocus={() => !focused && setDatepickerVisible(true)}
          onKeyDown={(e) => {
            if (e.key === 'Tab') {
              setDatepickerVisible(false);
              setFocused(false);
            }
          }}
        />
      </div>
    </>
  );
}
